'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _components2 = require('../../components');

var _components = {
  _$PostHero: {
    displayName: 'PostHero'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostHero.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostSingle/PostHero.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostHero = (function (_Component) {
  _inherits(PostHero, _Component);

  function PostHero() {
    _classCallCheck(this, _PostHero);

    _Component.apply(this, arguments);
  }

  PostHero.prototype.render = function render() {
    var post = this.props.post;

    var styles = {
      bgimage: {
        backgroundImage: 'url("' + post.featured_image_full + '")'
      },
      bgcolor: {
        backgroundColor: post.bgcolor ? post.bgcolor : '#0e7d9a'
      }
    };

    return _react2['default'].createElement(
      'div',
      { className: 'hero hero--post-full animated fadeInScale', style: styles.bgcolor },
      _react2['default'].createElement('div', { className: 'hero__bg-img', style: styles.bgimage }),
      _react2['default'].createElement(
        'div',
        { className: 'hero__content' },
        _react2['default'].createElement(
          'div',
          { className: 'hero__sub-heading' },
          post.subtitle ? post.subtitle.rendered : ''
        ),
        _react2['default'].createElement(
          'h1',
          { className: 'hero__heading' },
          post.title.rendered
        )
      ),
      _react2['default'].createElement(_components2.PostDetails, { post: post })
    );
  };

  _createClass(PostHero, null, [{
    key: 'propTypes',
    value: {
      post: _react.PropTypes.object.isRequired
    },
    enumerable: true
  }]);

  var _PostHero = PostHero;
  PostHero = _wrapComponent('_$PostHero')(PostHero) || PostHero;
  return PostHero;
})(_react.Component);

exports['default'] = PostHero;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PostSingle/PostHero.js
// module id = 672
// module chunks = 0